import { render, staticRenderFns } from "./AppointmentCheckDetailDispatch.vue?vue&type=template&id=2ad64a33"
import script from "./AppointmentCheckDetailDispatch.vue?vue&type=script&lang=js"
export * from "./AppointmentCheckDetailDispatch.vue?vue&type=script&lang=js"
import style0 from "./AppointmentCheckDetailDispatch.vue?vue&type=style&index=0&id=2ad64a33&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports